import React, { useRef, useState } from "react";
import axios from "axios";
import { Box, Button, CircularProgress, TextField } from "@mui/material";

const MediaUploadField = ({
  label,
  name,
  value,
  folder,
  accept,
  required = false,
  onChange,
  onError,
  onSuccess,
  helperText = "",
}) => {
  const apiUrl = process.env.REACT_APP_API_URL || "/api";
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const handleManualChange = (event) => {
    onChange(name, event.target.value);
  };

  const handleFileSelect = async (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const token = localStorage.getItem("token");
    if (!token) {
      onError?.("Você precisa estar autenticado para enviar arquivos.");
      event.target.value = "";
      return;
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("folder", folder);

    try {
      setUploading(true);
      const response = await axios.post(`${apiUrl}/upload`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      const uploadedUrl = response?.data?.url || "";
      if (!uploadedUrl) throw new Error("Resposta inválida do upload.");

      onChange(name, uploadedUrl);
      onSuccess?.(`Arquivo enviado com sucesso: ${file.name}`);
    } catch (error) {
      const backendMessage = error?.response?.data?.error || error?.response?.data?.message;
      onError?.(backendMessage || "Falha ao enviar arquivo.");
    } finally {
      setUploading(false);
      event.target.value = "";
    }
  };

  return (
    <Box>
      <TextField
        fullWidth
        label={label}
        name={name}
        value={value || ""}
        onChange={handleManualChange}
        required={required}
        helperText={helperText}
      />
      <Box sx={{ mt: 1, display: "flex", gap: 1, alignItems: "center" }}>
        <input
          ref={inputRef}
          type="file"
          accept={accept}
          hidden
          onChange={handleFileSelect}
        />
        <Button
          variant="outlined"
          onClick={() => inputRef.current?.click()}
          disabled={uploading}
        >
          {uploading ? "Enviando..." : "Selecionar arquivo"}
        </Button>
        {uploading && <CircularProgress size={18} />}
      </Box>
    </Box>
  );
};

export default MediaUploadField;
